import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { map, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ProductService } from 'src/app/services/product.service';
import { StoplistService } from 'src/app/services/stoplist.service';
import { Drink } from 'src/interfaces/drink.model';
import { Food } from 'src/interfaces/food.model';
import { LocalizationService } from 'src/app/services/localization.service';
import { Locale } from 'src/interfaces/locale.model';

@Component({
    selector: 'app-menu-recomendations',
    templateUrl: './menu-recomendations.component.html',
    styleUrls: ['./menu-recomendations.component.css'],
    standalone: false
})

export class MenuRecomendationsComponent implements OnInit, OnDestroy {
  constructor(
    private dataService: DataService, 
    private productService: ProductService,
    private stoplistService: StoplistService,
    public localization: LocalizationService,
    private cdr: ChangeDetectorRef,
  ) {
    this.locale = this.dataService.locale;

    this.recommendedFoods = [];
    this.recommendedDrinks = [];

    this.stoplistFoods = [];
    this.stoplistDrinks = [];

    // Получаем ширину экрана
    this.vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    this.vw = Math.min(this.vw, 480);
    this.height = 100;
   }

  @Input() recomendations: string[] = [];

  locale: Locale | null = null;

  recommendedFoods: Food[];
  recommendedDrinks: Drink[];

  private stoplistFoods: string[];
  private stoplistDrinks: string[];

  private destroy$ = new Subject<void>();

  private vw: number;
  height: number;

  ngOnInit(): void {
    // console.log('MenuRecomendations | ngOnInit()');

    // Subscribe to stoplist foods
    this.stoplistService.foods$
    .pipe(takeUntil(this.destroy$))
    .subscribe(stoplistFoods => {
      // console.log('MenuRecomendations | ngOnInit() | subscribe() stoplistFoods: ', stoplistFoods.map(x => x).join(', '));
      this.stoplistFoods = stoplistFoods;
    });
    
    // Subscribe to stoplist drinks
    this.stoplistService.drinks$
    .pipe(takeUntil(this.destroy$))
    .subscribe(stoplistDrinks => {
      // console.log('MenuRecomendations | ngOnInit() | subscribe() stoplistDrinks: ', stoplistDrinks.map(x => x).join(', '));
      this.stoplistDrinks = stoplistDrinks;
    });

    // foods
    this.productService.foods$.pipe(
      takeUntil(this.destroy$),
      map(foods => foods.filter(food => this.recomendations.includes(food.id))),
    ).subscribe(filtered => {
        // console.log('MenuRecomendations | ngOnInit() | subscribe() | foods: ', filtered.length);
        if (filtered.length) {
          this.recommendedFoods = filtered.filter(food => !this.stoplistFoods.includes(food.id));
        } else {
          this.recommendedFoods = [];
        }
      });

    // drinks
    this.productService.drinks$.pipe(
      takeUntil(this.destroy$),
      map(drinks => drinks.filter(drink => this.recomendations.includes(drink.id))),
    ).subscribe(filtered => {
        // console.log('MenuRecomendations | ngOnInit() | subscribe() | drinks: ', filtered.length);
        if (filtered.length) {
          this.recommendedDrinks = filtered.filter(drink => !this.stoplistDrinks.includes(drink.id));
        } else {
          this.recommendedDrinks = [];
        }
      });
  }

  ngAfterViewInit() {
    const width = (Math.min(this.vw || 480) - 18) / 1.6;
    this.height = width * 0.40;
    this.cdr.detectChanges(); // Обновляем Angular-поток изменений
  }

  ngOnDestroy(): void {
    // Отписка при уничтожении компонента
    this.destroy$.next();
    this.destroy$.complete();
  }
}
